'use client';

import dynamic from 'next/dynamic';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import MetaTags from '@/components/meta-tag/meta-tag';
import TechnologyFaq from '@/components/technologies/technology-faq';
import Blog from '@/components/home/blog';
import HireProcessAimlDev from '@/components/technologies/hire-process-aimldev';
import EnterpriseDataEngineering from '@/components/common/enterprise-data-engineering';
import ValuePropositionDataEngineering from '@/components/common/value-proposition-data-engineering';
import WhyDataEngineering from '@/components/common/why-data-engineering';
import OurOfferingDataEngineering from '@/components/common/our-offering-data-engineering';
import ArchitectureDiagramDataEngineering from '@/components/common/architecture-diagram-data-engineering';
import IntegrationsTechDataEngineering from '@/components/common/integrations-tech-data-engineering';
import DataEngineeringTechStack from '@/components/home/data-engineering-tech-stack';
import DataEngineeringFAQ from '@/components/faqs/data-engineering-faq';
import TechnicalApproachDataEngineering from '@/components/common/technical-approach-data-engineering';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHeroDataEngineeringFoundations = dynamic(() => import('@/components/technologies/tech-hero-data-engineering-foundations'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <div className="dark:bg-black">
                <TechHeroDataEngineeringFoundations />
                <EnterpriseDataEngineering />
                <ValuePropositionDataEngineering />
                <WhyDataEngineering />
                <OurOfferingDataEngineering />
                <TechnicalApproachDataEngineering />
                <ArchitectureDiagramDataEngineering />
                <IntegrationsTechDataEngineering />
                <DataEngineeringTechStack />
                <HireProcessAimlDev
                    bg="bg-black"
                    pageTitle="Our AI/ML Development Process"
                    desc="Maximize the possibilities of the newest AI/ML version. You can hire our AI/ML developers, who are competent in the technical and interactive abilities required to meet your project's objectives."
                />
                <TechnologyFaq title="FAQs for Data Engineering & Foundations" bg="bg-aiml-faq">
                    <DataEngineeringFAQ />
                </TechnologyFaq>
                <CaseStudies />
                <section className="">
                    <ClientTestimonials />
                </section>
                <Blog />
                <div className="section bg-primary py-100 dark:text-light dark:bg-black dark:pt-1">
                    <div className="container lg:container md:mx-auto">
                        <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                            <ContactForm />
                            <ContactInfo />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
